import { useEffect } from "react";

const SITE = "https://symbicognitive.com";

// Lightweight per-route meta — updates the document head on navigation.
export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    document.title = title;

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el && value) el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[name="twitter:title"]', "content", title);

    const url = SITE + path;
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:url"]', "content", url);
  }, [title, description, path]);

  return null;
};

export default Seo;
